var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto mt-6 mb-6",attrs:{"max-width":"344","to":{
    path: _vm.notice.link,
    query: {
      description: this.notice.description,
      capa2: this.notice.capa2,
      paragraph: this.notice.paragraph,
      title: this.notice.title,
      images: this.notice.images
    }
  }}},[_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.notice.title))])],1)],1),_c('v-img',{attrs:{"src":require(("../../../../styles/drawable-info/Cancro Europeu/" + (_vm.notice.capa))),"height":"194"}}),_c('v-card-text',[_vm._v(" "+_vm._s(_vm._f("truncate")(_vm.notice.paragraph,100, "..."))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }